// Shared avatar catalog for kid profile pickers.
// 12 emoji-based avatars — Step 1 placeholder set. Phase 2 swaps these for
// hand-illustrated Fajr Arabi characters once Nano Banana style refs land.
// The `slug` is what's persisted on learners.avatar; the `emoji` is rendered.

export interface AvatarOption {
  slug: string;
  emoji: string;
  /** Used as alt text + aria-label. Kept short and localizable. */
  label: string;
}

export const AVATAR_CATALOG: ReadonlyArray<AvatarOption> = [
  { slug: 'lion', emoji: '🦁', label: 'Lion' },
  { slug: 'fox', emoji: '🦊', label: 'Fox' },
  { slug: 'tiger', emoji: '🐯', label: 'Tiger' },
  { slug: 'panda', emoji: '🐼', label: 'Panda' },
  { slug: 'koala', emoji: '🐨', label: 'Koala' },
  { slug: 'monkey', emoji: '🐵', label: 'Monkey' },
  { slug: 'bunny', emoji: '🐰', label: 'Rabbit' },
  { slug: 'bear', emoji: '🐻', label: 'Bear' },
  { slug: 'cat', emoji: '🐱', label: 'Cat' },
  { slug: 'dog', emoji: '🐶', label: 'Dog' },
  { slug: 'penguin', emoji: '🐧', label: 'Penguin' },
  { slug: 'owl', emoji: '🦉', label: 'Owl' },
];

export function avatarBySlug(slug: string | null | undefined): AvatarOption | undefined {
  if (!slug) return undefined;
  return AVATAR_CATALOG.find((a) => a.slug === slug);
}
